import React from "react";
import ContactBanner from "./ContactBanner";
import ContactContent from "./ContactContent";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
class ContactUs extends React.Component {
  render() {
    return (
      <div>
        <ContactBanner />
        <ContactContent />
        <StayTouch />
      </div>
    );
  }
}

export default layoutWrapper(ContactUs);



// WEBPACK FOOTER //
// ./src/pages/contact/index.js